import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { getLiveStatus } from '../LiveBand/liveStatus';
import { setLook } from '../Navigation/navigationReducer';
import { LOOK_NAMES, otherLook, switchHref } from '../Look/look';
import useLook from '../Look/useLook';

const LIVE_RESULTS = 'https://liveresults.asaj.com.jm';

// Navy strip above the header. The dot pulses red while a meet is live
// (styled from body.is-live, which LiveBand sets). Log in is hidden by CSS
// once logged in, when Volto adds body.has-toolbar.
//
// It is also where the look is applied, because it sits on every page: the
// look's class goes on the body (the classic look is styled from
// body.look-classic), the phone menu is told which menu to show, and the
// link on the right switches to the other look.
const UtilityBar = ({ content }) => {
  const liveResultsUrl =
    getLiveStatus(content)?.live_results_url ?? LIVE_RESULTS;
  const look = useLook();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLook(look));
  }, [dispatch, look]);

  return (
    <div className="asaj-util">
      <BodyClass className={`look-${look}`} />
      <div className="asaj-util-inner">
        <a href={liveResultsUrl} target="_blank" rel="noopener noreferrer">
          <span className="asaj-ldot" aria-hidden="true" />
          Live results
        </a>
        <UniversalLink href="/contact" className="asaj-hide-sm">
          Contact
        </UniversalLink>
        <a
          href={switchHref(pathname, otherLook(look))}
          className="asaj-look-switch"
          rel="nofollow"
        >
          Try the {LOOK_NAMES[otherLook(look)]}
        </a>
        <UniversalLink href="/login" className="asaj-login">
          Log in
        </UniversalLink>
      </div>
    </div>
  );
};

export default UtilityBar;
